import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import OttoCredentialsSubSubTab from "./Credentials/OttoCredentials";
import PlentyCredentialsSubSubTab from "../../Credentials/PlentyCredentials";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const OttoTab = () => {
  const [ottoSubTab, setOttoSubTab] = useState(0);

  const handleOttoSubTabChange = (event, newValue) => {
    setOttoSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={ottoSubTab}
              onChange={handleOttoSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Otto" />
              <Tab label="Plenty" />
            </Tabs>
          </Box>

          {/* Credentials Tab */}
          <TabPanel value={ottoSubTab} index={0}>
            <OttoCredentialsSubSubTab />
          </TabPanel>

          {/* Articles Tab */}
          <TabPanel value={ottoSubTab} index={1}>
            <PlentyCredentialsSubSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OttoTab;
